module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Expand-arrows-37bc63de5bd71466a2736b6712603421.svg";